<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-16 16:25:41
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:05:19
 * @name: 全部琴行
 * @Description: 全部琴行
 * @FilePath: \preSaleNafterSaleBackstage\src\components\waresGoodsManage\dialog\all-piano-company.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <addNeditDialog ref="addNeditDialog" title="全部琴行" @close="close">
    <template v-slot:form>
      <div class="list" v-if="waresGoods.allPianoComponey.length > 0">
        <div
          class="item"
          v-for="item of waresGoods.allPianoComponey"
          :key="item.id"
        >
          <font>{{ item | agencyNameFilter }}</font>
          <font @click="deletePianoCompany(item.id)">删除</font>
        </div>
      </div>
      <div class="tips" v-else>暂未添加琴行</div>
    </template>
    <template v-slot:btnGroup>
      <el-button type="primary" @click="submit()">确认</el-button>
    </template>
  </addNeditDialog>
</template>
<script>
import { confirmation, debounceation } from "@/utils/decorator";
import addNeditDialog from "./addNeditDialog";

export default {
  name: "waresGoodsManage-allPianoCompany",
  components: {
    addNeditDialog,
  },
  props: {
    waresGoods: {
      type: Object,
    },
  },
  data() {
    return {
      id: "", //商品级别id
      updated: "", //有过更改
    };
  },
  filters: {
    agencyNameFilter(e) {
      return e?.agency?.agency_name ?? "";
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {Object} row 商品级别项数据
     */
    open(row) {
      this.id = row.id;
      this.updated = false;
      this.waresGoods.allPianoComponey = [];
      this.waresGoods.agencyGoodsGetAllList({ goods_level_id: this.id });
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗回调
     */
    close() {
      this.updated && this.$emit("editAllPianoCompanyHandler");
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗
     */
    @debounceation(300)
    cancel() {
      this.$refs.addNeditDialog.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击确认
     */
    @debounceation(300)
    submit() {
      this.cancel();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 删除琴行
     * @param {Number} id 级别琴行id
     */
    @confirmation("确认删除该琴行?")
    deletePianoCompany(id) {
      this.waresGoods
        .deletePianoCompany({ agency_goods_id: id })
        .then((res) => {
          this.waresGoods.agencyGoodsGetAllList({ goods_level_id: this.id });
          this.updated = true;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  width: 240px;
  display: grid;
  @include grid-row(auto, auto, 15px);
  .item {
    @extend .extend-flex-spacebetween;
    font {
      font-size: $Vars-font-content-size;
      &:nth-child(2) {
        font-size: $Vars-font-secondary-size;
        &:hover {
          color: $Vars-normal-color;
          @extend .extend-clickElement;
        }
      }
    }
  }
}
.tips {
  font-size: 24px;
  color: $Vars-font-secondary-color;
}
.el-button {
  margin-left: 40px;
  width: $Var-button-width-normal;
  &:first-child {
    margin-left: 0;
  }
}
</style>